export const NAME = 'organization_blogs'
export const ITEMS_PER_PAGE = 9
